<template>
<div class="gatewayConfiguration">
  <el-card class="box-card" shadow="never">
    <div class="wrap-page">
      <el-button type="primary" size="small" @click="openDialog('add', {})" style="margin-bottom: 20px;">新增</el-button>
      <el-table ref="dataPointTable" :data="tableData" border highlight-current-row height="70vh" style="width: 100%;">
        <el-table-column type="index" label="序号" width="150">
        </el-table-column>
        <el-table-column prop="name" label="名称">
        </el-table-column>
        <el-table-column prop="address" label="地址">
        </el-table-column>
        <el-table-column prop="version" label="版本">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="250">
          <template slot-scope="{ row }">
            <el-button class="btn" type="text" size="small" @click="openDialog('edit', row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
  <Dialog ref="gatewayDialog" :title="dialogTitle + '配置'">
    <el-form :model="gatewayData" label-width="120px">
      <el-form-item label="名称:">
        <el-input v-model="gatewayData.name" placeholder="名称" style="width: 90%;"></el-input>
      </el-form-item>
      <el-form-item label="地址:">
        <el-input v-model="gatewayData.address" placeholder="地址" style="width: 90%;"></el-input>
      </el-form-item>
      <el-form-item label="版本:">
        <el-input v-model="gatewayData.version" placeholder="版本" style="width: 90%;"></el-input>
      </el-form-item>
      <el-form-item label="webSocket:">
        <el-form :inline="true" v-for="(item, index) in webSocketAddressList" :key="index">
          <el-form-item>
            <el-input v-model="item.webSocketAddress" placeholder="webSocket地址" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="addFormData(index)"></el-button>
            <el-button v-if="webSocketAddressList.length>1" type="danger" size="mini" icon="el-icon-minus" circle @click="delFormData(index)"></el-button>
          </el-form-item>
        </el-form>
      </el-form-item>
      <el-form-item label="是否开户:">
        <el-radio-group v-model="gatewayData.radio">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="默认网关设置:">
        <el-form label-width="120px" style="width: 90%;border: 1px solid #ccc;border-radius: 6px;margin-top: 30px;padding-top: 10px;">
          <el-form-item label="超时时间:">
            <el-input v-model="gatewayData.name" placeholder="超时时间" style="width: 90%;"></el-input>
          </el-form-item>
          <el-form-item label="最大并行线程:">
            <el-input v-model="gatewayData.address" placeholder="最大并行线程" style="width: 90%;"></el-input>
          </el-form-item>
          <el-form-item label="间隔睡眠窗口:">
            <el-input v-model="gatewayData.address" placeholder="间隔睡眠窗口" style="width: 90%;"></el-input>
          </el-form-item>
          <el-form-item label="错误率百分比:">
            <el-input v-model="gatewayData.address" placeholder="错误率百分比" style="width: 90%;"></el-input>
          </el-form-item>
          <el-form-item label="请求量阈值:">
            <el-input v-model="gatewayData.address" placeholder="请求量阈值" style="width: 90%;"></el-input>
          </el-form-item>
        </el-form>
      </el-form-item>
      <el-form-item label="接口配置:">
        <el-form label-width="120px" style="width: 90%;border: 1px solid #ccc;border-radius: 6px;margin-top: 30px;padding-top: 10px;">
          <el-form-item label="名称:">
            <el-input v-model="gatewayData.name" placeholder="名称" style="width: 90%;"></el-input>
          </el-form-item>
          <el-form-item label="超时时间:">
            <el-input v-model="gatewayData.name" placeholder="超时时间" style="width: 90%;"></el-input>
          </el-form-item>
          <el-form-item label="最大并行线程:">
            <el-input v-model="gatewayData.address" placeholder="最大并行线程" style="width: 90%;"></el-input>
          </el-form-item>
          <el-form-item label="间隔睡眠窗口:">
            <el-input v-model="gatewayData.address" placeholder="间隔睡眠窗口" style="width: 90%;"></el-input>
          </el-form-item>
          <el-form-item label="错误率百分比:">
            <el-input v-model="gatewayData.address" placeholder="错误率百分比" style="width: 90%;"></el-input>
          </el-form-item>
          <el-form-item label="请求量阈值:">
            <el-input v-model="gatewayData.address" placeholder="请求量阈值" style="width: 90%;"></el-input>
          </el-form-item>
        </el-form>
      </el-form-item>
      <el-form-item label="IP管控:">
        <el-checkbox-group v-model="ipCheckList">
          <el-checkbox :label="1">
            <el-input v-model="gatewayData.second" placeholder="请输入" style="width: 150px;margin: 0px 10px;"></el-input>
            <span>1s</span>
          </el-checkbox>
          <el-checkbox :label="2">
            <el-input v-model="gatewayData.minute" placeholder="请输入" style="width: 150px;margin: 0px 10px;"></el-input>
            <span>1m</span>
          </el-checkbox>
          <el-checkbox :label="3">
            <el-input v-model="gatewayData.hour" placeholder="请输入" style="width: 150px;margin: 0px 10px;"></el-input>
            <span>1h</span>
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="用户管控:">
        <el-checkbox-group v-model="userCheckList">
          <el-checkbox :label="1">
            <el-input v-model="gatewayData.userSecond" placeholder="请输入" style="width: 150px;margin: 0px 10px;"></el-input>
            <span>1s</span>
          </el-checkbox>
          <el-checkbox :label="2">
            <el-input v-model="gatewayData.userMinute" placeholder="请输入" style="width: 150px;margin: 0px 10px;"></el-input>
            <span>1m</span>
          </el-checkbox>
          <el-checkbox :label="3">
            <el-input v-model="gatewayData.userHour" placeholder="请输入" style="width: 150px;margin: 0px 10px;"></el-input>
            <span>1h</span>
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </template>
  </Dialog>
</div>
</template>

<script>
import Dialog from '@/components/dialog';
export default {
  data() {
    return {
      tableData: [],
      dialogTitle: '新增',
      gatewayData: {
        name: '',
        address: '',
        version: '',
        webSocketAddress: '',
        radio: 1,
        gatewaySettings: ''
      },
      webSocketAddressList: [{
        webSocketAddress: ''
      }],
      ipCheckList: [],
      userCheckList: [],
    };
  },
  components: {
    Dialog
  },
  created() {},
  mounted() {},
  watch: {},
  methods: {
    openDialog(type, row) {
      if (type == "add") {
        this.dialogTitle = '新增';
        this.gatewayData = {};
      } else {
        this.dialogTitle = '修改';
        this.gatewayData = row;
      }
      this.type = type;
      this.$refs.gatewayDialog.open();
    },
    addFormData(index) {
      this.webSocketAddressList.push({
        webSocketAddress: ''
      });
    },
    //删除表单字段中文名称
    delFormData(index) {
      this.webSocketAddressList.splice(index, 1);
    },
  }
};
</script>

<style lang="scss" scoped>
.gatewayConfiguration {
  .box-card {
    width: 100%;
    height: 100%;
    padding-bottom: 10px;
  }

  >>>.el-dialog--center .el-dialog__body {
    height: 60vh;
    overflow: auto;
  }

  >>>.el-form-item .el-form-item {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/gatewayConfiguration/index.vue